export const FIRM_ICON_MAPPING = {
	organisations: 'building',
	environments: 'house',
	billingInfos: 'euro',
}
